import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, Output, EventEmitter, HostListener } from '@angular/core';
import { SortPipe } from '../../pipe/sort.pipe';
import { Column } from '../../models/column';
import { Distinct } from '../../models/distinct';
import { HelperService } from '../../Services/Helper.Service';

@Component({
  selector: 'mdg-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div *ngIf="showFilter" class='mdg-filter-container'>
  <div class="mdg-filter-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6" title="{{column.displayName}}">
            <h3>{{column.displayName}}</h3>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
            <div class="mdg-filter-sort">
              <div>
                <h3>Sort : </h3>
              </div>
              <div class="sortby" [class.bg-f7f7f7]='distValue.sort === "asc"' (click)='selectSort("asc")'>A-Z</div>
              <div class="sortby" [class.bg-f7f7f7]='distValue.sort === "desc"' (click)='selectSort("desc")'>Z-A</div>
            </div>
          </div>
        </div>
        <hr class="buffer-5-0">
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content">
        <div class='border-top-ddd border-left-ddd border-right-ddd'>
          <div class="padding-5 bg-f7f7f7" *ngIf="showFilterSearch">
            <input class="mdg-toolbar-search-input" [(ngModel)]='searchFilterText' (keyup)='onFilterSearch()' (keydown)='onFilterSearch()' placeholder="Search Values...">
            <div class="pull-right right-buffer-5">
              <i class='fa fa-times cursor-pointer' (click)='showFilterSearch = !showFilterSearch; searchFilterText = ""; onFilterSearch()'></i>
            </div>
          </div>
          <div *ngIf="!showFilterSearch" class="padding-5 bg-f7f7f7">List of Values
            <div class="pull-right right-buffer-5">
              <i class='fa fa-search cursor-pointer padding-right-5' (click)='showFilterSearch = !showFilterSearch'></i>
              <i class='fa cursor-pointer' (click)='checkSelection()' [class.fa-check-square-o]='selectAll' [class.padding-right-2]='!selectAll'
                [class.fa-square-o]='!selectAll'></i>
            </div>
          </div>
        </div>
        <div class="mdg-filter-stack-container overflow-y border-ddd">
          <div class="border-bottom-ddd padding-5 mdg-filter-cell" *ngFor="let col of svalues" [class.text-bold]='col.checked' title="{{ col.value | format:column }}">
            <div>
              <i class='fa fa-reorder cursor-move font-10'></i>
            </div>
            <div>{{ col.value | format:column }}</div>
            <div>
              <i class='fa cursor-pointer' (click)='addFilter(col)' [class.fa-check-square-o]='col.checked' [class.fa-square-o]='!col.checked'></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <hr class="buffer-5-0">
        <div class='row'>
          <div class="col-xs-12 text-lg-right text-md-right text-sm-right">
            <button class='btn btn-sm btn-primary right-buffer-10' (click)='applyFilter()'>Apply</button>
            <button class='btn btn-sm btn-default' (click)='showFilter = false'>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
})
export class MDGFilterComponent {
  column: Column = new Column();
  values: any[] = [];
  svalues: any[] = [];
  distValue: Distinct = new Distinct();
  @Output() updateFilters: EventEmitter<Distinct> = new EventEmitter<Distinct>();
  showFilter: boolean = false;
  selectAll: boolean = false;
  showFilterSearch: boolean = false;
  searchFilterText: string = '';

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showFilter) {
      this.showFilter = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private sort: SortPipe, private helper: HelperService) {
    this.column.header = this.helper.getHeaderStyle();
    this.column.cell = this.helper.getCellStyle();
  }

  ShowFilter(col: Column, distValue: Distinct) {
    this.column = col;
    this.searchFilterText = '';
    this.showFilterSearch = false;
    this.distValue = distValue;
    this.values = this.sort.transformString(this.distValue.values, this.distValue.sort).map(f => {
      return { 'value': f, 'checked': !this.distValue.filter.includes(f) };
    });
    this.svalues = this.values;
    this.checkAllSelected();
    this.showFilter = true;
    this.detectChanges();
  }

  onFilterSearch() {
    setTimeout(() => {
      if (this.searchFilterText !== undefined && this.searchFilterText !== null && this.searchFilterText !== '') {
        this.svalues = this.values.filter(f => f.value && f.value != null ? f.value.toLowerCase().includes(this.searchFilterText.toString().toLowerCase()) : false);
      } else {
        this.svalues = this.values;
        this.cdRef.markForCheck();
      }
    }, 50);
  }

  updateValue() {
    this.svalues = this.sort.transformString(this.distValue.values, this.distValue.sort).map(f => {
      return { 'value': f, 'checked': this.values.filter(v => v.value === f && v.checked === true).length > 0 };
    });
  }

  selectSort(sort: any) {
    if (this.distValue.sort !== sort) {
      this.distValue.sort = sort;
    } else {
      this.distValue.sort = '';
    }
    this.updateValue();
  }

  checkAllSelected() {
    this.selectAll = this.svalues.filter(f => f.checked).length === this.values.length;
  }

  addFilter(col: any) {
    col.checked = !col.checked;
    this.checkAllSelected();
  }

  checkSelection() {
    this.selectAll = !this.selectAll;
    this.svalues.forEach(col => {
      col.checked = this.selectAll;
    });
  }

  applyFilter() {
    this.distValue.filter = this.svalues.filter(f => f.checked === false).map(m => m.value);
    setTimeout(() => {
      this.updateFilters.emit(this.distValue);
    }, 10);
    this.showFilter = false;
  }

  getDisplayDate(input: string) {
    return (new Date(input)).toLocaleDateString();
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
